export default __webpack_public_path__ + "files/a89a48b5516e19ef6d90474fb0a16894.png";